// ss-gtm-consent-bridge.js
(function () {
  window.dataLayer = window.dataLayer || [];
  window.gtag = window.gtag || function () { window.dataLayer.push(arguments); };

  const asGranted = (b) => (b ? 'granted' : 'denied');

  // Default: denied totdat Shopify consent API iets anders zegt
  gtag('consent', 'default', {
    ad_storage: 'denied',
    ad_user_data: 'denied',
    ad_personalization: 'denied',
    analytics_storage: 'denied',
    functionality_storage: 'denied',
    personalization_storage: 'denied',
    security_storage: 'granted',
    wait_for_update: 5000
  });

  function applyFromShopify(cp) {
    const marketing = !!cp?.marketingAllowed?.();
    const analytics = !!cp?.analyticsProcessingAllowed?.();
    const prefs     = !!cp?.preferencesProcessingAllowed?.();
    const sale      = (typeof cp?.saleOfDataAllowed === 'function') ? !!cp.saleOfDataAllowed() : true;

    gtag('consent', 'update', {
      analytics_storage: asGranted(analytics),
      ad_storage: asGranted(marketing),
      ad_user_data: asGranted(marketing),
      ad_personalization: asGranted(marketing && sale),
      functionality_storage: asGranted(prefs),
      personalization_storage: asGranted(prefs),
      security_storage: 'granted'
    });

    // Debug (optioneel):
    // window.dataLayer.push({event:'shopify_consent_update', marketing, analytics, prefs, sale});
  }

  function bind(cp) {
    applyFromShopify(cp);

    const onChange = () => applyFromShopify(cp);
    document.addEventListener('visitorConsentCollected', onChange);
    document.addEventListener('visitorConsentUpdated',   onChange); // als aanwezig
  }

  let loadRequested = false;

  function loadAndBind() {
    if (window.Shopify?.customerPrivacy) {
      bind(window.Shopify.customerPrivacy);
      return true;
    }

    if (!loadRequested && window.Shopify?.loadFeatures) {
      loadRequested = true;
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (error) => {
        if (!error && window.Shopify?.customerPrivacy) bind(window.Shopify.customerPrivacy);
      });
    }

    return false;
  }

  // Sommige setups emitten dit event als de API klaar is
  document.addEventListener('shopifyCustomerPrivacyApiLoaded', loadAndBind);

  // Poll max 5s
  const t0 = Date.now();
  (function tick() {
    if (loadAndBind()) return;
    if (Date.now() - t0 < 5000) setTimeout(tick, 50);
  })();
})();